import React, {useState, useEffect} from 'react';
import {Link, useLocation, useParams} from 'react-router';
import ToggleDropdown from './ProductsDD';
import customizerLogo from '../../img/customizer-logo.svg';
import {getUserStoresWithProducts} from "../../services/apiService";
import {useTelemetryContext} from "../../contexts/TelemetryContext";

function SideBar({tabactive, tabactive2}) {
    const [activeTab, setActiveTab] = useState(tabactive);
    const [isTelemetryVisible, setIsTelemetryVisible] = useState(true);
    const {
        selectedProduct,
        setSelectedProduct,
        stores,
        setStores,
        selectedStore,
        setSelectedStore
    } = useTelemetryContext();
    const location = useLocation();

    const {storeId, productId} = useParams();

    const storeIdParam = storeId || selectedProduct?.store_id;
    const productIdParam = productId || selectedProduct?.id;


    useEffect(() => {
        setActiveTab(tabactive);
        setIsTelemetryVisible(false);
    }, [tabactive]);

    useEffect(() => {
        if (storeIdParam && productIdParam && stores.length > 0) {
            let selectedProduct = null;

            // Iterate over all stores to find the product with the matching productIdParam
            for (const store of stores) {
                selectedProduct = store.products.find(product => product.id === (productIdParam * 1));
                if (selectedProduct) {
                    break; // Exit the loop if the product is found
                }
            }

            // Set the selected product if found, otherwise default to the first product of the first store
            setSelectedProduct(selectedProduct || stores[0].products[0]);
            setSelectedStore(selectedStore || stores[0]);
        } else {
            // If no productIdParam is provided, use the store from the URL (a store page opened in a
            // new tab), else the first store, and default to its first product.
            const store = (storeIdParam && stores.find(s => s.id === (storeIdParam * 1))) || stores[0];
            if (store && store.products && store.products.length > 0) {
                setSelectedProduct(store.products[0]);
                setSelectedStore(store);
            }
        }

        if (isActive(location.pathname)) {
            setIsTelemetryVisible(true);
        }

        if (location.pathname === '/add-product' || location.pathname === '/add-store') {
            setIsTelemetryVisible(false);
        }

    }, [location.pathname, stores]);


    useEffect(() => {
        // Only fetch stores if they haven't been fetched yet
        if (!selectedProduct&&stores.length < 1) {
            getUserStoresWithProducts()
                .then(data => {
                    setStores(data);
                })
                .catch(error => console.error('Error fetching products:', error));
        }
    }, [selectedProduct, productIdParam]);


    const isActive = (path) => location.pathname.startsWith(path) ? 'telemetry-active' : '';

    // Ctrl/Cmd/Shift/Alt or middle click opens the link in a new tab/window: leave this tab as it is.
    const isPlainClick = (e) => e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;

    const handleProductTabClick = (tabIndex, product) => (e) => {
        if (!isPlainClick(e)) {
            return;
        }
        setActiveTab(tabIndex);
        setSelectedProduct(product);
        setIsTelemetryVisible(true);
    };

    const handleStoreTabClick = (tabIndex, store) => (e) => {
        if (!isPlainClick(e)) {
            return;
        }
        setActiveTab(tabIndex);
        setSelectedStore(store);
        setIsTelemetryVisible(true);
    };

    return (
        <>
            <ToggleDropdown activeTab={activeTab} setActiveTab={setActiveTab}
                            setIsTelemetryVisible={setIsTelemetryVisible} isTelemetryVisible={isTelemetryVisible}/>


            {/* All Stores Tab */}
            {activeTab === 0 && !isTelemetryVisible && <>

                {stores.map(store => (
                    <div key={store.id} className='telemetry-logo-wrapper product-list'>
                        <Link to={`/stores/${store.id}/dashboard`} className="products store-title"
                              onClick={handleStoreTabClick(0, store)}>
                            <img src={store.logo_url || customizerLogo} alt={store.title}/>
                            <div className="customize-text">
                                <h3>{store.title} ({store.products.length})</h3>
                            </div>
                        </Link>

                    </div>
                ))}

                <div className="telemetry-nav">
                    <ul>
                        <li className={isActive("/add-store")}><Link to={"/add-store"}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
                                    fill="currentColor"/>
                            </svg>
                            Add New Store</Link></li>
                    </ul>
                </div>
            </>}

            {/* Selected Store Tab */}
            {activeTab === 0 && isTelemetryVisible && <>

                <div key={selectedStore?.id} className='telemetry-logo-wrapper product-list'>
                    <div className="products store-title">
                        <img src={selectedStore?.logo_url || customizerLogo} alt={selectedStore?.title}/>
                        <div className="customize-text">
                            <h3>{selectedStore?.title} ({selectedStore?.products.length})</h3>
                        </div>
                    </div>
                </div>
                <div className="telemetry-nav">
                    <ul>
                        <li className={isActive(`/stores/${storeId}/dashboard`)}>
                            <Link to={`/stores/${storeId}/dashboard`}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <g id="dashboard" clipPath="url(#clip0_359_95)">
                                        <path
                                            d="M20 4V7H15V4H20ZM9 4V11H4V4H9ZM20 13V19H15V13H20ZM9 17V19H4V17H9ZM22 2H13V9H22V2ZM11 2H2V13H11V2ZM22 11H13V21H22V11ZM11 15H2V21H11V15Z"
                                            fill="#939CA4"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_359_95">
                                            <rect width="24" height="24" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                                Dashboard
                            </Link>
                        </li>
                        <li className={isActive(`/stores/${storeId}/users`)}>
                            <Link to={`/stores/${storeId}/users`}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <g id="outlined/user-group">
                                        <path
                                            d="M14.167 16.6666H18.3337V15C18.3336 14.4804 18.1717 13.9738 17.8704 13.5505C17.5692 13.1272 17.1435 12.8083 16.6526 12.6381C16.1617 12.4679 15.63 12.4549 15.1314 12.6008C14.6327 12.7468 14.192 13.0445 13.8703 13.4525M14.167 16.6666H5.83366M14.167 16.6666V15C14.167 14.4533 14.062 13.9308 13.8703 13.4525M13.8703 13.4525C13.5609 12.6791 13.0268 12.0162 12.337 11.5492C11.6472 11.0823 10.8333 10.8327 10.0003 10.8327C9.16734 10.8327 8.35346 11.0823 7.66366 11.5492C6.97386 12.0162 6.43979 12.6791 6.13033 13.4525M5.83366 16.6666H1.66699V15C1.66703 14.4804 1.82894 13.9738 2.13021 13.5505C2.43148 13.1272 2.85715 12.8083 3.34803 12.6381C3.83892 12.4679 4.37064 12.4549 4.86927 12.6008C5.36791 12.7468 5.80868 13.0445 6.13033 13.4525M5.83366 16.6666V15C5.83366 14.4533 5.93866 13.9308 6.13033 13.4525M12.5003 5.83331C12.5003 6.49635 12.2369 7.13224 11.7681 7.60108C11.2993 8.06992 10.6634 8.33331 10.0003 8.33331C9.33728 8.33331 8.7014 8.06992 8.23256 7.60108C7.76372 7.13224 7.50033 6.49635 7.50033 5.83331C7.50033 5.17027 7.76372 4.53439 8.23256 4.06555C8.7014 3.59671 9.33728 3.33331 10.0003 3.33331C10.6634 3.33331 11.2993 3.59671 11.7681 4.06555C12.2369 4.53439 12.5003 5.17027 12.5003 5.83331ZM17.5003 8.33331C17.5003 8.77534 17.3247 9.19926 17.0122 9.51182C16.6996 9.82438 16.2757 9.99998 15.8337 9.99998C15.3916 9.99998 14.9677 9.82438 14.6551 9.51182C14.3426 9.19926 14.167 8.77534 14.167 8.33331C14.167 7.89129 14.3426 7.46736 14.6551 7.1548C14.9677 6.84224 15.3916 6.66665 15.8337 6.66665C16.2757 6.66665 16.6996 6.84224 17.0122 7.1548C17.3247 7.46736 17.5003 7.89129 17.5003 8.33331ZM5.83366 8.33331C5.83366 8.77534 5.65806 9.19926 5.3455 9.51182C5.03294 9.82438 4.60902 9.99998 4.16699 9.99998C3.72496 9.99998 3.30104 9.82438 2.98848 9.51182C2.67592 9.19926 2.50033 8.77534 2.50033 8.33331C2.50033 7.89129 2.67592 7.46736 2.98848 7.1548C3.30104 6.84224 3.72496 6.66665 4.16699 6.66665C4.60902 6.66665 5.03294 6.84224 5.3455 7.1548C5.65806 7.46736 5.83366 7.89129 5.83366 8.33331Z"
                                            stroke="#939CA4" strokeWidth="2" strokeLinecap="round"
                                            strokeLinejoin="round"/>
                                    </g>
                                </svg>
                                Users
                            </Link>
                        </li>
                        <li className={isActive(`/stores/${storeId}/sites`)}>
                            <Link to={`/stores/${storeId}/sites`}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <g id="outlined/globe-alt">
                                        <path
                                            d="M17.5 10C17.5 11.9891 16.7098 13.8968 15.3033 15.3033C13.8968 16.7098 11.9891 17.5 10 17.5M17.5 10C17.5 8.01088 16.7098 6.10322 15.3033 4.6967C13.8968 3.29018 11.9891 2.5 10 2.5M17.5 10H2.5M10 17.5C8.01088 17.5 6.10322 16.7098 4.6967 15.3033C3.29018 13.8968 2.5 11.9891 2.5 10M10 17.5C11.3808 17.5 12.5 14.1417 12.5 10C12.5 5.85833 11.3808 2.5 10 2.5M10 17.5C8.61917 17.5 7.5 14.1417 7.5 10C7.5 5.85833 8.61917 2.5 10 2.5M10 2.5C8.01088 2.5 6.10322 3.29018 4.6967 4.6967C3.29018 6.10322 2.5 8.01088 2.5 10"
                                            stroke="#939CA4" strokeWidth="2" strokeLinecap="round"
                                            strokeLinejoin="round"/>
                                    </g>
                                </svg>
                                Sites
                            </Link>
                        </li>
                        <li className={isActive(`/stores/${storeId}/eventslog`)}>
                            <Link to={`/stores/${storeId}/eventslog`}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <g id="outlined/calendar">
                                        <path
                                            d="M6.66667 5.83333V2.5M13.3333 5.83333V2.5M5.83333 9.16667H14.1667M4.16667 17.5H15.8333C16.2754 17.5 16.6993 17.3244 17.0118 17.0118C17.3244 16.6993 17.5 16.2754 17.5 15.8333V5.83333C17.5 5.39131 17.3244 4.96738 17.0118 4.65482C16.6993 4.34226 16.2754 4.16667 15.8333 4.16667H4.16667C3.72464 4.16667 3.30072 4.34226 2.98816 4.65482C2.67559 4.96738 2.5 5.39131 2.5 5.83333V15.8333C2.5 16.2754 2.67559 16.6993 2.98816 17.0118C3.30072 17.3244 3.72464 17.5 4.16667 17.5Z"
                                            stroke="#939CA4" strokeWidth="2" strokeLinecap="round"
                                            strokeLinejoin="round"/>
                                    </g>
                                </svg>
                                Events Log
                            </Link>
                        </li>
                        <li className={isActive(`/stores/${storeId}/settings`)}>
                            <Link to={`/stores/${storeId}/settings`}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <g id="filled/image/tune">
                                        <path
                                            d="M11 16.5H10.5V17V18.5H9.5V13.5H10.5V15V15.5H11H18.5V16.5H11ZM5 9.5H5.5V9V7.5H6.5V12.5H5.5V11V10.5H5H1.5V9.5H5ZM15 4.5H14.5V5V6.5H13.5V1.5H14.5V3V3.5H15H18.5V4.5H15ZM6.5 16.5H1.5V15.5H6.5V16.5ZM10.5 4.5H1.5V3.5H10.5V4.5ZM9.5 9.5H18.5V10.5H9.5V9.5Z"
                                            fill="#181E34" stroke="#939CA4"/>
                                    </g>
                                </svg>
                                Settings
                            </Link>
                        </li>
                    </ul>
                </div>
            </>}

            {/* All Products Tab */}
            {activeTab === 1 && !isTelemetryVisible && <>
                <div className="">
                    {stores.map(store => (
                        <div key={store.id} className='telemetry-logo-wrapper product-list'>
                            <div className="products store-title">
                                <img src={store.logo_url || customizerLogo} alt={store.title}/>
                                <div className="customize-text">
                                    <h3>{store.title}</h3>
                                </div>
                            </div>
                            {store.products.map(product => (
                                <Link key={product.id} className='products'
                                      to={`/stores/${product.store_id}/plugins/${product.id}/dashboard`}
                                      onClick={handleProductTabClick(1, product)}>
                                    <img src={product.icon || customizerLogo} alt={product.name}/>
                                    <div className="customize-text">
                                        <h3>{product.name}</h3>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    ))}
                </div>
                <div className="telemetry-nav">
                    <ul>
                        <li className={isActive("/add-product")}><Link to={"/add-product"}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
                                    fill="currentColor"/>
                            </svg>
                            Add Product / Bundle</Link></li>
                    </ul>
                </div>
            </>}

            {/* Selected Products Tab */}
            {activeTab === 1 && isTelemetryVisible &&
                <div className={`telemetry-links-store ${activeTab === 1 ? 'show' : 'hide'}`}>
                    <div className="telemetry-logo-wrapper products">
                        <Link to={`/stores/${storeId}/plugins/${productId}/dashboard`}>
                            <img src={selectedProduct?.icon || customizerLogo} alt={selectedProduct?.name}/>
                            <div className="customize-text">
                                <h3>{selectedProduct?.name}</h3>
                                <span className="text-muted">{selectedProduct?.slug}</span>
                            </div>
                        </Link>
                    </div>
                    <div className="telemetry-nav">
                        <ul>
                            <li className={isActive(`/stores/${storeId}/plugins/${productId}/dashboard`)}>
                                <Link to={`/stores/${storeId}/plugins/${productId}/dashboard`}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <g id="dashboard" clipPath="url(#clip0_359_95)">
                                            <path
                                                d="M20 4V7H15V4H20ZM9 4V11H4V4H9ZM20 13V19H15V13H20ZM9 17V19H4V17H9ZM22 2H13V9H22V2ZM11 2H2V13H11V2ZM22 11H13V21H22V11ZM11 15H2V21H11V15Z"
                                                fill="#939CA4"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_359_95">
                                                <rect width="24" height="24" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    Dashboard
                                </Link>
                            </li>
                            <li className={isActive(`/stores/${storeId}/plugins/${productId}/users`)}>
                                <Link to={`/stores/${storeId}/plugins/${productId}/users`}>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <g id="outlined/user-group">
                                            <path
                                                d="M14.167 16.6666H18.3337V15C18.3336 14.4804 18.1717 13.9738 17.8704 13.5505C17.5692 13.1272 17.1435 12.8083 16.6526 12.6381C16.1617 12.4679 15.63 12.4549 15.1314 12.6008C14.6327 12.7468 14.192 13.0445 13.8703 13.4525M14.167 16.6666H5.83366M14.167 16.6666V15C14.167 14.4533 14.062 13.9308 13.8703 13.4525M13.8703 13.4525C13.5609 12.6791 13.0268 12.0162 12.337 11.5492C11.6472 11.0823 10.8333 10.8327 10.0003 10.8327C9.16734 10.8327 8.35346 11.0823 7.66366 11.5492C6.97386 12.0162 6.43979 12.6791 6.13033 13.4525M5.83366 16.6666H1.66699V15C1.66703 14.4804 1.82894 13.9738 2.13021 13.5505C2.43148 13.1272 2.85715 12.8083 3.34803 12.6381C3.83892 12.4679 4.37064 12.4549 4.86927 12.6008C5.36791 12.7468 5.80868 13.0445 6.13033 13.4525M5.83366 16.6666V15C5.83366 14.4533 5.93866 13.9308 6.13033 13.4525M12.5003 5.83331C12.5003 6.49635 12.2369 7.13224 11.7681 7.60108C11.2993 8.06992 10.6634 8.33331 10.0003 8.33331C9.33728 8.33331 8.7014 8.06992 8.23256 7.60108C7.76372 7.13224 7.50033 6.49635 7.50033 5.83331C7.50033 5.17027 7.76372 4.53439 8.23256 4.06555C8.7014 3.59671 9.33728 3.33331 10.0003 3.33331C10.6634 3.33331 11.2993 3.59671 11.7681 4.06555C12.2369 4.53439 12.5003 5.17027 12.5003 5.83331ZM17.5003 8.33331C17.5003 8.77534 17.3247 9.19926 17.0122 9.51182C16.6996 9.82438 16.2757 9.99998 15.8337 9.99998C15.3916 9.99998 14.9677 9.82438 14.6551 9.51182C14.3426 9.19926 14.167 8.77534 14.167 8.33331C14.167 7.89129 14.3426 7.46736 14.6551 7.1548C14.9677 6.84224 15.3916 6.66665 15.8337 6.66665C16.2757 6.66665 16.6996 6.84224 17.0122 7.1548C17.3247 7.46736 17.5003 7.89129 17.5003 8.33331ZM5.83366 8.33331C5.83366 8.77534 5.65806 9.19926 5.3455 9.51182C5.03294 9.82438 4.60902 9.99998 4.16699 9.99998C3.72496 9.99998 3.30104 9.82438 2.98848 9.51182C2.67592 9.19926 2.50033 8.77534 2.50033 8.33331C2.50033 7.89129 2.67592 7.46736 2.98848 7.1548C3.30104 6.84224 3.72496 6.66665 4.16699 6.66665C4.60902 6.66665 5.03294 6.84224 5.3455 7.1548C5.65806 7.46736 5.83366 7.89129 5.83366 8.33331Z"
                                                stroke="#939CA4" strokeWidth="2" strokeLinecap="round"
                                                strokeLinejoin="round"/>
                                        </g>
                                    </svg>
                                    Users
                                </Link>
                            </li>
                            <li className={isActive(`/stores/${storeId}/plugins/${productId}/sites`)}>
                                <Link to={`/stores/${storeId}/plugins/${productId}/sites`}>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <g id="outlined/globe-alt">
                                            <path
                                                d="M17.5 10C17.5 11.9891 16.7098 13.8968 15.3033 15.3033C13.8968 16.7098 11.9891 17.5 10 17.5M17.5 10C17.5 8.01088 16.7098 6.10322 15.3033 4.6967C13.8968 3.29018 11.9891 2.5 10 2.5M17.5 10H2.5M10 17.5C8.01088 17.5 6.10322 16.7098 4.6967 15.3033C3.29018 13.8968 2.5 11.9891 2.5 10M10 17.5C11.3808 17.5 12.5 14.1417 12.5 10C12.5 5.85833 11.3808 2.5 10 2.5M10 17.5C8.61917 17.5 7.5 14.1417 7.5 10C7.5 5.85833 8.61917 2.5 10 2.5M10 2.5C8.01088 2.5 6.10322 3.29018 4.6967 4.6967C3.29018 6.10322 2.5 8.01088 2.5 10"
                                                stroke="#939CA4" strokeWidth="2" strokeLinecap="round"
                                                strokeLinejoin="round"/>
                                        </g>
                                    </svg>
                                    Sites
                                </Link>
                            </li>
                            <li className={isActive(`/stores/${storeId}/plugins/${productId}/eventslog`)}>
                                <Link to={`/stores/${storeId}/plugins/${productId}/eventslog`}>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <g id="outlined/calendar">
                                            <path
                                                d="M6.66667 5.83333V2.5M13.3333 5.83333V2.5M5.83333 9.16667H14.1667M4.16667 17.5H15.8333C16.2754 17.5 16.6993 17.3244 17.0118 17.0118C17.3244 16.6993 17.5 16.2754 17.5 15.8333V5.83333C17.5 5.39131 17.3244 4.96738 17.0118 4.65482C16.6993 4.34226 16.2754 4.16667 15.8333 4.16667H4.16667C3.72464 4.16667 3.30072 4.34226 2.98816 4.65482C2.67559 4.96738 2.5 5.39131 2.5 5.83333V15.8333C2.5 16.2754 2.67559 16.6993 2.98816 17.0118C3.30072 17.3244 3.72464 17.5 4.16667 17.5Z"
                                                stroke="#939CA4" strokeWidth="2" strokeLinecap="round"
                                                strokeLinejoin="round"/>
                                        </g>
                                    </svg>
                                    Events Log
                                </Link>
                            </li>
                            <li className={isActive(`/stores/${storeId}/plugins/${productId}/top-features`)}>
                                <Link to={`/stores/${storeId}/plugins/${productId}/top-features`}>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.33301 16.6667V9.16669M8.33301 16.6667V3.33335M13.333 16.6667V10.8334M18.333 16.6667H1.66634"
                                              stroke="#939CA4" strokeWidth="2" strokeLinecap="round"
                                              strokeLinejoin="round"/>
                                    </svg>
                                    Top Features
                                </Link>
                            </li>
                            <li className={isActive(`/stores/${storeId}/plugins/${productId}/integration`)}>
                                <Link to={`/stores/${storeId}/plugins/${productId}/integration`}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                 <circle cx="10" cy="10" r="9" stroke="#939CA4" strokeWidth="2" /> 
                                 <path d="M5 10H15" stroke="#939CA4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /> 
                                 <path d="M10 5V15" stroke="#939CA4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /> 
                                 <circle cx="10" cy="5" r="1" fill="#939CA4" /> <circle cx="10" cy="15" r="1" fill="#939CA4" /> 
                                 <circle cx="5" cy="10" r="1" fill="#939CA4" /> <circle cx="15" cy="10" r="1" fill="#939CA4" /> 
                                 </svg>
                                    SDK Integration
                                </Link>
                            </li>
                            <li className={isActive(`/stores/${storeId}/plugins/${productId}/email-setup`)}>
                                <Link to={`/stores/${storeId}/plugins/${productId}/email-setup`}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="2" y="5" width="16" height="12" rx="2" stroke="#939CA4" strokeWidth="1.5" />
                                <path d="M2 5L10 11L18 5" stroke="#939CA4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                   Emails
                                </Link>
                            </li>
                            <li className={isActive(`/stores/${storeId}/plugins/${productId}/settings`)}>
                                <Link to={`/stores/${storeId}/plugins/${productId}/settings`}>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <g id="filled/image/tune">
                                            <path
                                                d="M11 16.5H10.5V17V18.5H9.5V13.5H10.5V15V15.5H11H18.5V16.5H11ZM5 9.5H5.5V9V7.5H6.5V12.5H5.5V11V10.5H5H1.5V9.5H5ZM15 4.5H14.5V5V6.5H13.5V1.5H14.5V3V3.5H15H18.5V4.5H15ZM6.5 16.5H1.5V15.5H6.5V16.5ZM10.5 4.5H1.5V3.5H10.5V4.5ZM9.5 9.5H18.5V10.5H9.5V9.5Z"
                                                fill="#181E34" stroke="#939CA4"/>
                                        </g>
                                    </svg>
                                    Settings
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>}
        </>
    );
}

export default SideBar;
